import { atom } from 'jotai';

// Tracks API request status for each job/version
// Structure: { [`${version}_${job}`]: { success: boolean, message?: string } }
export const apiStatusAtom = atom({});